export const environment = {
  production: true,
  serverUrl: 'https://webchat.pscnet.com.tw',
  customerServiceKeyword: '轉接真人客服',
  domain: '*',
  allowedUploadFileExts: [
    '.jpg',
    '.jpeg',
    '.bmp',
    '.pdf',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.ppt',
    '.pptx',
    '.mp4',
    '.m4v',
    '.qt',
    '.mov',
    '.m4a',
    '.avi',
    '.wmv',
    '.asf',
    '.mpeg',
    '.mpg',
    '.vob',
    '.mkv',
    '.asf',
    '.rmvb',
    '.rm',
    '.vob',
    '.ts',
    '.dat',
  ],
};
